import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { foods, wines } from '../data/wines';
import { getAvailableFoods } from '../utils/foodPairingUtils';
import ArrowLeftIcon from './icons/ArrowLeftIcon';

const FoodList = () => {
  const navigate = useNavigate();

  // Filtra apenas comidas que têm vinhos visíveis associados
  const availableFoods = useMemo(() => {
    return getAvailableFoods(foods, wines);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-wine-dark via-[#1e1a2e] to-wine-dark py-8 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex items-center mb-8">
          <button 
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-white hover:text-wine-gold transition-colors"
          >
            <ArrowLeftIcon />
            <span className="text-lg">Voltar</span>
          </button>
        </div>

        {/* Title */}
        <div className="text-center mb-12">
          <h1 className="text-white text-3xl md:text-4xl font-serif mb-4">
            O que você vai comer?
          </h1>
          <p className="text-gray-400 text-lg">
            Escolha o prato e vamos sugerir o vinho perfeito
          </p>
        </div>

        {/* Food Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {availableFoods.map((food) => (
            <div
              key={food.id}
              onClick={() => navigate(`/wines/pairing/${food.id}`)}
              className="cursor-pointer group"
            >
              <div className="bg-gradient-to-br from-[#2a2535] to-[#1a1625] rounded-2xl p-6 hover:scale-105 hover:shadow-xl hover:shadow-wine-gold/20 transition-all duration-300 border border-transparent hover:border-wine-gold/50">
                {/* Food Icon */}
                <div className="text-6xl mb-4 text-center group-hover:scale-110 transition-transform duration-300">
                  {food.icon}
                </div>
                
                {/* Food Info */}
                <h3 className="text-white text-xl font-serif text-center mb-3">
                  {food.name}
                </h3>
                <p className="text-gray-400 text-sm text-center mb-4">
                  {food.description}
                </p>
                
                {/* Examples */}
                <div className="border-t border-gray-700 pt-4">
                  <p className="text-wine-gold text-xs uppercase tracking-wide mb-2 text-center">
                    Exemplos:
                  </p>
                  <div className="flex flex-wrap gap-2 justify-center">
                    {food.examples.slice(0, 3).map((example, index) => (
                      <span 
                        key={index}
                        className="text-xs bg-wine-dark px-2 py-1 rounded-full text-gray-300"
                      >
                        {example}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FoodList;

